import './index.less';
import { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import localStore from '@/global/store/local-store';
import { graphicStore } from '@/global/store/graphic-store';
import { TnEngineContext, TnEngineExtraContext, AxisT, ttf, font, ModelBase, Point, Line } from 'pytha';
import { cmdRegister } from './cmd-register';
import { AmbientLight, Color, DirectionalLight, Mesh, MeshBasicMaterial, PointLight, Scene, SphereGeometry } from 'three';
import Viewport from './viewport';
import genUUID from '@/global/utils/gen-uuid';
import { MaskLoadingModal } from 'tncet-common';
import axios from 'axios';
import { CommonTabbarContext, SideContext, SystemContext, TabContext } from '@/App';
import { SystemStatus } from '@/global/store/system-store';
import { Ucs } from '@/global/interface/ucs';
import { findGlobalUcs, findUcsInProject } from '@/api/geometry/ucs';
import { findLayersInProjectUuid } from '@/api/geometry/layer';
import { Layer } from '@/global/interface/layer';
import { findFontGlyphs, findFontTtfs, findFontsInGraphic } from '@/api/geometry/font';
import { Primitive } from '@/global/interface/primitive';
import { createPrimitive, findPrimitivesInGraphic } from '@/api/geometry/primitive';
import { createPrimitiveMulti, deletePrimitivesInGraphic } from '@/api/geometry/primitive';
import { getProjects, initProject } from '@/api/project-manage/project';
import { DymodeInput } from "pytha-ui";
import SystemSwitch from './system-switch';
import StmodeInput from '@/global/components/stmode-input';
import { TabStatus } from '@/global/store/tab-store';
import { TAB_TYPE } from '@/enums/tab-type';
import { CommonTabbarState, TabRoute } from '@/global/components/common-tabbar';
import { ModelsInArchiBase } from '@/passets/archibase-engine/models';
import { createDataBox, deleteDataBoxByPrimitiveUuid, updateDataBox } from '@/api/device/data-box';
import { SideStatus } from '@/global/store/side-store';
import { createSensor, deleteSensorByPrimitiveUuid, updateSensor } from '@/api/device/sensor';
import { DataBox } from '@/global/interface/device/data-box';
import { Sensor } from '@/global/interface/device/sensor';
import { DEVICEBASE_SINGAL } from '@/passets/devicebase-engine/enums/devicebase-singal';
import { MonixAddPrimitivesCommand } from '@/passets/pytha-engine/commands/MonixAddPrimitivesCommand';
import TnMessage from '@/global/components/message';
import DeviceDetailPop from './device-detail-pop';
import { CableT } from '@/passets/devicebase-engine/models/CableT';
import { DeviceComponentT } from '@/passets/devicebase-engine/models/DeviceComponentT';
import { DataBoxModelTypes, DeviceLevelTableDict, DeviceModelTypes, SensorModelTypes, getDeviceTypeLevels } from '@/enums/model-type';
import { changeCableConnect, createCable, deleteCable, deleteCableByPrimitiveUuid } from '@/api/device/cable';
import { Cable } from '@/global/interface/device/cable';
import { PYTHA_SINGAL } from '@/passets/pytha-engine/enums/pytha-signal';
import { MonixUpdatePrimitivesCommand } from '@/passets/pytha-engine/commands/MonixUpdatePrimitivesCommand';
import SensorParamPop from './sensor-param-pop';
import { getMonitorObjectEntitiesByProjectId } from '@/api/monitor-object/monitor-object';
import { MonitorObjectEntity } from '@/global/interface/monitor-object/monitor-object';
import { Project } from '@/global/interface/project-manage/project';
import { ModelsInBimCommon } from 'tnbimbase';

const sideBarWidth = 0;
interface Iprops {
    tabTitle?: string;
    tabClosable?: boolean;
}
export default function DrawTabPage(props: Iprops) {
    const { projectId, drawKey, roofSlabUuid, gutterUuid } = useParams();
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingTip, setLoadingTip] = useState<string>('');
    const [sceneUpdate, setSceneUpdate] = useState<string>(''); // 场景更新的信号
    const sideContext = useContext<SideStatus>(SideContext);
    const systemContext = useContext<SystemStatus>(SystemContext);
    const drawRef = useRef(null);
    const location = useLocation();
    const tabbarContext = useContext<CommonTabbarState>(CommonTabbarContext);
    const isInit = useRef<boolean>(false)

    useEffect(() => {
        let tabUrl = `${TAB_TYPE.DRAW}/${drawKey}`;
        if (!!roofSlabUuid) {
            tabUrl = `${TAB_TYPE.ROOF_SLAB}/${roofSlabUuid}`;
        } else if (!!gutterUuid) {
            tabUrl = `${TAB_TYPE.GUTTER}/${gutterUuid}`;
        }
        let drawTab: TabRoute = {
            title: props.tabTitle ? props.tabTitle : "绘图区",
            url: tabUrl,
            closable: props.tabClosable != null ? props.tabClosable : false,
        }
        tabbarContext.pushRoute(drawTab);
    }, [drawKey, roofSlabUuid, gutterUuid])

    useEffect(() => {
        if (!roofSlabUuid && !gutterUuid && !drawKey) {
            return
        }
        if (isInit.current) {
            initModels();
        }
    }, [location])

    // const [block, setBlock] = useState<Block>();
    const initScene = () => {
        return new Promise((resolve, reject) => {
            if (graphicStore.extraContext.sceneContext.scene == null) {
                let scene = new Scene();

                // 在初始化部分添加光源
                // 添加光照
                const ambientLight = new AmbientLight(0xffffff, 1);
                scene.add(ambientLight);

                // const directionalLight = new DirectionalLight(0xffffff, 0.8);
                // directionalLight.position.set(1, 1, 1).normalize();
                // directionalLight.castShadow = true; // 使光源投射阴影
                // scene.add(directionalLight);

                // const directionalLight1 = new DirectionalLight(0xffffff, 0.6);
                // directionalLight1.position.set(-1, 1, 1).normalize();
                // directionalLight1.castShadow = true; // 使光源投射阴影
                // scene.add(directionalLight1);

                // const directionalLight2 = new DirectionalLight(0xffffff, 0.7);
                // directionalLight2.position.set(1, 3, 1).normalize();
                // directionalLight2.castShadow = true; // 使光源投射阴影
                // scene.add(directionalLight2);
                // const sphere = new SphereGeometry(0.5, 16, 8);
                // const pointLight1 = new PointLight(0xffaa00, 4000, 1000000)
                // pointLight1.position.set(0, 0, 0)
                // pointLight1.add(new Mesh(sphere, new MeshBasicMaterial({ color: 0xff0040 })));
                // scene.add(pointLight1)

                // // 创建一个光源帮助器（可选）
                // const pointLightHelper = new PointLightHelper(pointLight1, 0.5);
                // scene.add(pointLightHelper);

                graphicStore.extraContext.sceneContext.scene = scene;

                setSceneUpdate(genUUID());
                resolve(1);
            }
        })
    }

    useEffect(() => {
        // 将命令api注册到图形库中
        cmdRegister();
    }, [])

    useEffect(() => {
        if (!projectId) {
            localStore.projectId = null;
            return () => { };
        }

        localStore.projectId = projectId;
        initScene();
        document.oncontextmenu = () => {
            return false;
        }
        if (graphicStore?.context) {
            Object.keys(ModelsInArchiBase).forEach(type => {
                graphicStore.context.modelContext.addEntitytoCtrl(type);
                graphicStore.context.modelContext.registerModel(type, ModelsInArchiBase[type]);
            })
            if (graphicStore.context) {
                Object.keys(ModelsInBimCommon).forEach(type => {
                    graphicStore.context.modelContext.addEntitytoCtrl(type);
                    graphicStore.context.modelContext.registerModel(type, ModelsInBimCommon[type]);
                })
            }
        }
        // 模型变化，更新数据
        generateData();
        window.addEventListener('resize', onWindowResize);
        return (() => {
            window.removeEventListener('resize', onWindowResize);
            graphicStore.extraContext.sceneContext.scene.clear();
            graphicStore.extraContext.sceneContext.scene = null;
        })
    }, [projectId, systemContext?.updateDrawPanel])

    useEffect(() => {
        if (systemContext.showMonitorObjectEntities) {
            // 展示图元
            getMonitorObjectEntitiesByProjectId(+projectId).then(res => {
                let list: MonitorObjectEntity[] = res.data || [];
                let entities = list.map((item: MonitorObjectEntity) => {
                    let entity: ModelBase = new (graphicStore.context.modelContext.getModelConstructor(item.entity.type))();
                    entity.fromJson(item.entity);
                    entity.positionUpdateCallBack = true;
                    entity.extraData = { monitorObjectId: item.monitorObjectId };
                    return entity;
                });
                if (!!graphicStore.extraContext.getCurrentViewEditor()) {
                    const editor = graphicStore.extraContext.getCurrentViewEditor();
                    let showEntities = [];
                    entities.forEach(entity => {
                        if (!editor.entityDict[entity.uuid]) {
                            showEntities.push(entity);
                        }
                    })
                    graphicStore.extraContext.getCurrentViewEditor().addObjects(showEntities);
                }
            })
        } else {
            // 不展示图元
            getMonitorObjectEntitiesByProjectId(+projectId).then(res => {
                let list: MonitorObjectEntity[] = res.data || [];
                let entityUuids = list.map((item: MonitorObjectEntity) => {
                    return item.entity.uuid;
                });
                if (!!graphicStore.extraContext.getCurrentViewEditor()) {
                    graphicStore.extraContext.getCurrentViewEditor().removeObjectByUuids(entityUuids);
                }
            })
        }
    }, [systemContext.showMonitorObjectEntities])

    // 监听信号
    useEffect(() => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        // 特殊图元的变更（这里特指删除）
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onEntitiesUpdatePosition.add(onSpecialEntityUpdatePosition);
        // 设备布置完成
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleDeviceFinish).add(onAssembleDeviceFinish);
        // 数据线缆布置完成
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleCableFinish).add(onAssembleCableFinish);
        // 特殊图元的位置移动变更（move、夹点）
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(PYTHA_SINGAL.onEntitiesMovePosition).add(onEntitiesMovePosition);
        // 修改数据线缆头/尾设备
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onUpadteCableEndFinish).add(onUpadteCableEndFinish);
        return () => {
            if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
            graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onEntitiesUpdatePosition.remove(onSpecialEntityUpdatePosition);
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleDeviceFinish).remove(onAssembleDeviceFinish);
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleCableFinish).remove(onAssembleCableFinish);
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(PYTHA_SINGAL.onEntitiesMovePosition).remove(onEntitiesMovePosition);
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onUpadteCableEndFinish).remove(onUpadteCableEndFinish);
        }
    }, [graphicStore?.extraContext?.getCurrentViewEditor()])

    // 监听采集箱/传感器等图元的位置变化的处理
    const onSpecialEntityUpdatePosition = (deleteEntities: ModelBase[], isDelete: boolean) => {
        let devicePromiseList = [];
        // 采集箱
        let dataBoxEntities = deleteEntities?.filter(item => ['SerialT', 'DvrT', 'IpcT'].includes(item.type)) || [];
        if (dataBoxEntities?.length > 0) {
            for (let item of dataBoxEntities) {
                if (!item?.extraData?.globalDataBoxId) continue;
                if (isDelete) {
                    devicePromiseList.push(() => deleteDataBoxByPrimitiveUuid(item?.uuid));
                } else {
                    let par: DataBox = {
                        primitiveUuid: item.uuid,
                        globalDataBoxId: item?.extraData?.globalDataBoxId,
                        projectId: +projectId,
                    }
                    devicePromiseList.push(() => createDataBox(par));
                }
            }
        }
        // 传感器
        let sensorEntities = deleteEntities?.filter(item => item.type === 'AnemoclinographT' || item.type === 'FluviographT' || item.type === 'MonitorT') || [];
        if (sensorEntities?.length > 0) {
            for (let item of sensorEntities) {
                if (!item?.extraData?.globalSensorId) continue;
                if (isDelete) {
                    devicePromiseList.push(() => deleteSensorByPrimitiveUuid(item?.uuid));
                } else {
                    let par: Sensor = {
                        primitiveUuid: item.uuid,
                        globalSensorId: item?.extraData?.globalSensorId,
                        projectId: +projectId,
                    }
                    devicePromiseList.push(() => createSensor(par));
                }
            }
        }

        // 数据线缆
        let cablePromiseList = [];
        let cableEntities = deleteEntities?.filter(item => item.type === 'CableT') || [];
        if (cableEntities?.length > 0) {
            const editor = graphicStore?.extraContext?.getCurrentViewEditor();
            for (let item of cableEntities) {
                if (!item?.extraData) continue;
                if (isDelete) {
                    cablePromiseList.push(() => deleteCableByPrimitiveUuid(item?.uuid));
                    let lowDeviceEntity = editor?.entityDict[item?.extraData?.firstDeviceUuid];
                    if (lowDeviceEntity) {
                        (lowDeviceEntity as DeviceComponentT).connected = false;
                        cablePromiseList.push(() => createPrimitive(lowDeviceEntity.toJson()));
                        editor.addObject(lowDeviceEntity);
                    }
                } else {
                    const firstDevice = editor.entityDict[item?.extraData?.firstDeviceUuid]
                    const secondDevice = editor.entityDict[item?.extraData?.secondDeviceUuid]
                    if (!firstDevice || !secondDevice) continue;
                    let cable: Cable = {
                        primitiveUuid: item.uuid,
                        globalCableId: item?.extraData?.globalCableId || null,
                        projectId: +projectId,
                        lowLevelTable: DeviceLevelTableDict[getDeviceTypeLevels(firstDevice?.type)],
                        lowLevelPrimitiveUuid: item?.extraData?.firstDeviceUuid,
                        highLevelTable: DeviceLevelTableDict[getDeviceTypeLevels(secondDevice?.type)],
                        highLevelPrimitiveUuid: item?.extraData?.secondDeviceUuid,
                    }
                    cablePromiseList.push(() => createCable(cable));
                    let lowDeviceEntity = editor?.entityDict[item?.extraData?.firstDeviceUuid];
                    if (lowDeviceEntity) {
                        (lowDeviceEntity as DeviceComponentT).connected = true;
                        cablePromiseList.push(() => createPrimitive(lowDeviceEntity.toJson()));
                        editor.addObject(lowDeviceEntity);
                    }
                }
            }
            graphicStore?.extraContext?.getCurrentViewEditor().listeners.signals.needRender.dispatch('redraw');
        }

        axios.all(devicePromiseList?.map(fn => fn())).then(res => {
            sideContext.needRenderDataBoxSide();
            sideContext.needRenderSensorSide();

            axios.all(cablePromiseList?.map(fn => fn())).then(res2 => {
            }).catch(error => { });
        }).catch(error => { }).finally(() => { });


        // todo 监测对象
        let monitorObjectEntities = deleteEntities?.filter(item => item?.extraData?.monitorObjectId != null) || [];
        if (monitorObjectEntities.length > 0) {

        }
    }

    // 设备布置完成的回调
    const onAssembleDeviceFinish = (e) => {
        let addPris = e.addPris;
        graphicStore.extraContext.getCurrentViewEditor().history.execute(new MonixAddPrimitivesCommand(
            addPris,
            () => addDeviceExecuteCallback(addPris),
            () => addDeviceUndoCallback(addPris)
        ))
    }

    // 设备布置command的执行回调
    const addDeviceExecuteCallback = (addPris: ModelBase[]) => {
        createPrimitiveMulti(addPris?.map((entity: ModelBase) => {
            if (entity.toJson) {
                return entity.toJson();
            }
            return null
        })).then(() => {
            // 修改布置的采集箱/传感器信息
            if (addPris[0].type === 'DvrT' || addPris[0].type === 'SerialT' || addPris[0].type === 'IpcT') {
                let globalDataBoxId = addPris[0].extraData?.globalDataBoxId || null;
                if (!globalDataBoxId) return;
                let primitiveUuid = addPris[0].uuid;
                let par: DataBox = {
                    primitiveUuid: primitiveUuid,
                    globalDataBoxId: globalDataBoxId,
                    projectId: +projectId,
                }
                createDataBox(par).then(res => {
                    if (res.status === 200) {
                        TnMessage.success("布置成功");
                    }
                }).catch(err => {
                    TnMessage.error("布置失败");
                })
            } else if (addPris[0].type === 'AnemoclinographT' || addPris[0].type === 'FluviographT' || addPris[0].type === 'MonitorT') {
                console.log('addPris', addPris)
                let globalSensorId = addPris[0].extraData?.globalSensorId || null;
                if (!globalSensorId) return;
                let primitiveUuid = addPris[0].uuid;
                let par: Sensor = {
                    primitiveUuid: primitiveUuid,
                    globalSensorId: globalSensorId,
                    projectId: +projectId,
                }
                createSensor(par).then(res => {
                    if (res.status === 200) {
                        TnMessage.success("布置成功");
                    }
                }).catch(err => {
                    TnMessage.error("绑定失败");
                })
            }

        })
    }

    // 设备布置command的撤回回调
    const addDeviceUndoCallback = (addPris: ModelBase[]) => {
        deletePrimitivesInGraphic(addPris?.map(entity => entity.uuid)).then(res => {
            if (addPris[0].type === 'DvrT' || addPris[0].type === 'SerialT' || addPris[0].type === 'IpcT') {
                deleteDataBoxByPrimitiveUuid(addPris[0].uuid).then(res => {
                    if (res.status === 200) {
                        TnMessage.success("取消布置成功");
                    }
                }).catch(err => {
                    TnMessage.error("解绑失败");
                })
            } else if (addPris[0].type === 'AnemoclinographT' || addPris[0].type === 'FluviographT' || addPris[0].type === 'MonitorT') {
                deleteSensorByPrimitiveUuid(addPris[0].uuid).then(res => {
                    if (res.status === 200) {
                        TnMessage.success("取消布置成功");
                    }
                }).catch(err => {
                    TnMessage.error("解绑失败");
                })
            }

        });
    }

    // 数据线布置完成的回调
    const onAssembleCableFinish = (e) => {
        let addPris = e.addPris;
        let firstDevice = e.firstDevice;
        let secondDevice = e.secondDevice;
        graphicStore.extraContext.getCurrentViewEditor().history.execute(new MonixAddPrimitivesCommand(
            addPris,
            () => addCableExecuteCallback(addPris, firstDevice, secondDevice),
            () => addCableUndoCallback(addPris, firstDevice, secondDevice)
        ))
    }

    /**
     * 添加数据线执行回调
     * @param addPris 数据线对象数组
     * @param firstDevice 较低级设图元对象
     * @param secondDevice 较高级设图元对象
     */
    const addCableExecuteCallback = (addPris: ModelBase[], firstDevice: DeviceComponentT, secondDevice: DeviceComponentT) => {
        let cableEntity = addPris[0];
        let lowLevelTable = DeviceLevelTableDict[getDeviceTypeLevels(firstDevice.type)];
        let highLevelTable = DeviceLevelTableDict[getDeviceTypeLevels(secondDevice.type)];
        if (!cableEntity || !lowLevelTable || !highLevelTable || !firstDevice?.uuid || !secondDevice?.uuid) {
            TnMessage.error("布置失败");
            return;
        }
        let firstClone = firstDevice.clone();
        firstClone.uuid = firstDevice.uuid;
        firstClone.connected = true;
        let par = [cableEntity, firstClone];

        let cable: Cable = {
            primitiveUuid: cableEntity.uuid,
            globalCableId: cableEntity?.extraData?.globalCableId || null,
            projectId: +projectId,
            lowLevelTable: lowLevelTable,
            lowLevelPrimitiveUuid: firstDevice.uuid,
            highLevelTable: highLevelTable,
            highLevelPrimitiveUuid: secondDevice.uuid,
        }

        let priPromiseList = [];
        priPromiseList.push(createPrimitiveMulti(par?.map(e => e?.toJson() || null)));
        priPromiseList.push(createCable(cable));
        axios.all(priPromiseList).then(() => {
            TnMessage.success("布置成功");
        }).catch(err => {
            console.log('err', err)
            TnMessage.error("布置失败");
        })
    }

    /**
     * 添加数据线撤回回调
     * @param addPris 数据线对象数组
     * @param firstDevice 较低级设图元对象
     * @param secondDevice 较高级设图元对象
     */
    const addCableUndoCallback = (addPris: ModelBase[], firstDevice: DeviceComponentT, secondDevice: DeviceComponentT) => {
        let priPromiseList = [];
        // 图元：删除线缆图元，修改较低级设备连接状态
        priPromiseList.push(deletePrimitivesInGraphic(addPris?.map(entity => entity.uuid)));
        let firstClone = firstDevice.clone();
        firstClone.uuid = firstDevice.uuid;
        firstClone.connected = false;
        priPromiseList.push(createPrimitiveMulti([firstClone.toJson()]));
        // 业务：删除线缆对象，置空较低级设备外键
        priPromiseList.push(deleteCableByPrimitiveUuid(addPris[0].uuid));
        axios.all(priPromiseList).then(() => {
            TnMessage.success("取消布置成功");
        }).catch(err => {
            TnMessage.error("取消布置失败");
        })
    }

    // 特殊图元位置移动的回调
    const onEntitiesMovePosition = (moveEntities: DeviceComponentT[]) => {
        // 采集箱
        let deviceEntities: DeviceComponentT[] = moveEntities?.filter(item => DeviceModelTypes.some(t => t === item.type)) || [];
        if (deviceEntities?.length > 0) {
            const editor = graphicStore?.extraContext?.getCurrentViewEditor();
            // 获取extraData中，firstDeviceUuid 或者 secondDeviceUuid 为这个的
            let needModifyCables: CableT[] = editor.getEntities().filter(item => item.type === 'CableT'
                && item?.extraData?.firstDeviceUuid
                && item?.extraData?.secondDeviceUuid
                && deviceEntities.some(de => de.uuid === item.extraData.firstDeviceUuid || de.uuid === item.extraData.secondDeviceUuid)) || [];
            // if (needModifyCables?.length === 0) {
            //     editor.listeners.signals.needRender.dispatch('redraw');
            //     return;
            // }
            for (let cable of needModifyCables) {
                let idx1 = deviceEntities.findIndex(de => de.uuid === cable.extraData.firstDeviceUuid);
                if (idx1 !== -1) {
                    // 修改起点
                    let entity: DeviceComponentT = deviceEntities[idx1];
                    let geoCurvesAtfer = [...cable._geoCurves];
                    (geoCurvesAtfer[0] as Line).start.set(entity.position.x, entity.position.y, entity.position.z);
                    cable.setCurves(geoCurvesAtfer);
                    cable.needRedraw = true;
                    cable.getBoundingBox();
                }

                let idx2 = deviceEntities.findIndex(de => de.uuid === cable.extraData.secondDeviceUuid);
                if (idx2 !== -1) {
                    // 修改终点
                    let entity: DeviceComponentT = deviceEntities[idx2];
                    let geoCurvesAtfer = [...cable._geoCurves];
                    (geoCurvesAtfer[cable._geoCurves.length - 1] as Line).end.set(entity.position.x, entity.position.y, entity.position.z);
                    cable.setCurves(geoCurvesAtfer);
                    cable.needRedraw = true;
                    cable.getBoundingBox();
                }
            }
            editor.addObjects([...needModifyCables], true);
            editor.listeners.signals.needRender.dispatch('redraw');
            createPrimitiveMulti(needModifyCables.map(entity => {
                if (entity?.toJson) {
                    return entity.toJson();
                }
                return null
            }))

        }
    }

    // 修改数据线缆头/尾设备的回调
    const onUpadteCableEndFinish = (cable: CableT, location: string, level: number, deviceEntity: DeviceComponentT) => {
        let firstDevice: DeviceComponentT = graphicStore.extraContext.getCurrentViewEditor().entityDict[cable.extraData.firstDeviceUuid] as DeviceComponentT;
        let secondDevice: DeviceComponentT = graphicStore.extraContext.getCurrentViewEditor().entityDict[cable.extraData.secondDeviceUuid] as DeviceComponentT;
        let entities = [];
        let entitiesNew = [];
        graphicStore.extraContext.getCurrentViewEditor().selectControl.resetSelectedEntities();
        if (location === 'start') {
            let cableNew = cable.clone();
            cableNew.uuid = cable.uuid;
            cableNew.extraData = {
                ...cable.extraData,
                firstDeviceUuid: deviceEntity.uuid,
            }
            // 修改头节点位置
            let geoCurvesAtfer = [...cable._geoCurves];
            (geoCurvesAtfer[0] as Line).start.set(deviceEntity.position.x, deviceEntity.position.y, deviceEntity.position.z);
            cableNew.setCurves(geoCurvesAtfer);
            cableNew.needRedraw = true;
            cableNew.getBoundingBox();
            cable.needRedraw = true;


            let firstDeviceNew = firstDevice.clone();
            firstDeviceNew.uuid = firstDevice.uuid;
            firstDeviceNew.connected = false;

            let deviceEntityNew = deviceEntity.clone();
            deviceEntityNew.uuid = deviceEntity.uuid;
            deviceEntityNew.connected = true;
            entities = [cable, firstDevice, deviceEntity];
            entitiesNew = [cableNew, firstDeviceNew, deviceEntityNew];
            graphicStore.extraContext.getCurrentViewEditor().history.execute(new MonixUpdatePrimitivesCommand(
                entities,
                entitiesNew,
                () => updateCableEndCallback(location, level, deviceEntity, cableNew),
                () => updateCableEndCallback(location, level, firstDevice, cableNew),
            ))
        } else if (location === 'end') {
            let cableNew = cable.clone();
            cableNew.uuid = cable.uuid;
            cableNew.extraData = {
                ...cable.extraData,
                secondDeviceUuid: deviceEntity.uuid,
            }
            // 修改尾节点位置
            let geoCurvesAtfer = [...cable._geoCurves];
            (geoCurvesAtfer[cableNew._geoCurves?.length - 1] as Line).end.set(deviceEntity.position.x, deviceEntity.position.y, deviceEntity.position.z);
            cableNew.setCurves(geoCurvesAtfer);
            cableNew.needRedraw = true;
            cableNew.getBoundingBox();
            cable.needRedraw = true;
            entities = [cable];
            entitiesNew = [cableNew];
            graphicStore.extraContext.getCurrentViewEditor().history.execute(new MonixUpdatePrimitivesCommand(
                entities,
                entitiesNew,
                () => updateCableEndCallback(location, level, deviceEntity, cableNew),
                () => updateCableEndCallback(location, level, secondDevice, cableNew),
            ))
        }
    }

    /**
     * 外键可以通过level+primitiveUuid算出来
     * @param location 用来判断修改的是low部分还是high部分
     * @param level 确定数据表
     * @param newDeivceEntity 新连接的图元
     */
    const updateCableEndCallback = (location: string, level: number, newDeivceEntity: DeviceComponentT, cableNew: CableT) => {
        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.needRender.dispatch('redraw');
        createPrimitive(cableNew.toJson()).then(res => { })
        // 表名
        let tableName = DeviceLevelTableDict[getDeviceTypeLevels(newDeivceEntity.type)];
        let par: Cable = {};
        if (location === 'start') {
            // 修改头夹点，即修改low部分
            par = {
                primitiveUuid: cableNew.uuid,
                lowLevelTable: tableName,
                lowLevelPrimitiveUuid: newDeivceEntity.uuid,
            }
        } else if (location === 'end') {
            // 修改尾夹点，即修改high部分
            par = {
                primitiveUuid: cableNew.uuid,
                highLevelTable: tableName,
                highLevelPrimitiveUuid: newDeivceEntity.uuid,
            }
        }
        changeCableConnect(par).then(res => { }).catch(err => { })
    }

    const onWindowResize = () => {
        graphicStore.extraContext.listeners?.signals.windowResize.dispatch();
    }

    const generateData = () => {
        if (!projectId) return;
        setLoading(true);
        // 设置世界坐标的默认颜色
        graphicStore.context.renderContext.axisColor.set(new Color(0, 0, 0))
        // 设置鼠标默认颜色
        graphicStore.context.renderContext.cusorColor.set(new Color(0, 0, 1))
        initProjectInfo().then((_) => {
            return initUcs();
        }).then((_) => {
            return initLayers();
        }).then((_) => {
            return initFonts();
        }).then((_) => {
            // return initTexture();
            return
        }).then((_) => {
            return initModels();
        }).finally(() => {
            if (graphicStore?.extraContext?.getCurrentViewEditor()) {
                graphicStore.extraContext.getCurrentViewEditor()?.showAllEntities(true);
            }

            // TODO 全局设置
            graphicStore.context.renderContext.gridLineDistanceToCircle = 3000;
            graphicStore.context.renderContext.textHeight = 300;
            graphicStore.extraContext.listeners.signals.onEditStatusChanged.dispatch();

            if (graphicStore?.extraContext?.getCurrentViewEditor()) {
                graphicStore.extraContext.getCurrentViewEditor()?.viewCube.prepareAnimationData("vb");
                graphicStore.extraContext.getCurrentViewEditor().viewCube.animating = true;
            }
            setLoading(false);
        })
    }

    const initProjectInfo = () => {
        return new Promise((resolve, reject) => {
            setLoadingTip('正在加载项目');
            initProject(projectId).then(res => {
                if (res.status === 200) {
                    localStore.projectId = projectId;
                    resolve(1);
                }
            })
        })

    }

    const initUcs = () => {
        return new Promise((resolve, reject) => {
            setLoadingTip('正在加载坐标系');
            findUcsInProject(projectId).then(res => {
                let jsonList: Ucs[] = res.data || [];
                let ucsList = [];
                jsonList.forEach((json) => {
                    if (json.isWcs) return;
                    let ucs: AxisT = new AxisT().fromJson(json);
                    ucsList.push(ucs);
                });
                findGlobalUcs(projectId).then(res => {
                    let json = res.data;
                    let wcs = new AxisT().fromJson(json);
                    if (wcs != null) {
                        ucsList.push(wcs);
                    }
                    if (wcs == null && ucsList.length > 0) wcs = ucsList[0];
                    graphicStore.context.ucsContext.setUcsList(ucsList);
                    graphicStore.context.ucsContext.setCurrentUcs(wcs);
                    if (wcs != null) {
                        let viewObj = wcs.render();
                        graphicStore.extraContext.sceneContext.scene?.add(viewObj);
                    }
                    resolve(1);
                })
            })
        })
    }

    const initLayers = () => {
        return new Promise((resolve, reject) => {
            setLoadingTip('正在加载图层');
            findLayersInProjectUuid(projectId).then(res => {
                let layers: Layer[] = res.data || [];
                layers.forEach((layer) => {
                    layer.lock = false;
                    layer.hidden = false;
                });
                let originLayer = layers.find((layer) => layer.originLayer && layer.projectUuid == projectId);
                if (originLayer == null) originLayer = layers[0];
                if (originLayer != null) {
                    graphicStore.context.layerContext.setCurrentLayerUuid(originLayer.uuid);
                    graphicStore.context.layerContext.setCurrentLayerColor(originLayer.color);
                    graphicStore.context.layerContext.setCurrentColor(originLayer.color);
                }
                graphicStore.context.layerContext.setLayers([...layers]);
                resolve(1);
            })
        });
    };

    const initFonts = () => {
        return new Promise((resolve, reject) => {
            setLoadingTip('正在加载文字样式');
            // 初始化时加载标注所用字体及默认字体
            if (!!graphicStore.extraContext.fontContext.state.dimFontData && !!graphicStore.extraContext.fontContext.state.currentFont) {
                resolve(1);
            }
            let ttfPromise = findFontTtfs();
            let fontPromise = findFontsInGraphic(projectId);
            // 加载0~9和.所需要的glyphs
            let params = {
                unicodeFile: "times.ttf",
                rangeStart: 0,
                rangeEnd: 1919,
                bakFile: "stsong.ttf",
                text: '0123456789. \\:;/*=+-_abcdefghigklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
            };
            let glyphPromise = findFontGlyphs(params);
            axios.all([ttfPromise, fontPromise, glyphPromise]).then((res) => {

                if (graphicStore.extraContext.getCurrentViewEditor() == null) {
                    resolve(1);
                    return;
                }

                let ttfList: ttf[] = res[0].data || [];
                graphicStore.extraContext?.fontContext?.generateTtfNameList(ttfList);
                let fontList: font[] = res[1].data || [];
                let defaultFont;
                fontList.forEach((font) => {
                    let ttf = ttfList.find(
                        (item) => item.name === font.fontname && item.style === font.style
                    );
                    font.ttf = ttf;
                    if (font.originFont) {
                        defaultFont = font;
                    }
                });
                graphicStore.extraContext?.fontContext?.setFontList(fontList);
                if (!!defaultFont) {
                    graphicStore.extraContext?.fontContext?.setCurrentFont(defaultFont);
                }
                graphicStore.extraContext?.fontContext?.setDimFontData(res[2].data);
                resolve(1);
            });
        });
    }

    // const initTexture = () => {
    //     return new Promise((resolve, reject) => {
    //         setLoadingTip('正在加载纹理/材质');
    //         getTextures(projectId).then(res => {
    //             let textures: Texture[] = res.data || [];
    //             textures.forEach(texture => {
    //                 if (texture && texture.uuid && texture.url) {
    //                     let imageUrl = getTextureUrl(texture.url)
    //                     graphicStore.extraContext.materialContext.materialUrlMap[texture.uuid] = imageUrl;
    //                     // convertImageToBase64(imageUrl).then(res => {
    //                     //     graphicStore.extraContext.materialContext.materialBase64Map[texture.uuid] = res
    //                     // })
    //                 }
    //             })
    //             resolve(1);
    //         })
    //     });
    // }
    // TODO: 根据url获取base64，待解除 
    // async function convertImageToBase64(url) {
    //     let response = await fetch(url)
    //     let blob = await response.blob()
    //     return new Promise((resolve, reject) => {
    //         let reader = new FileReader()
    //         reader.onloadend = () => {
    //             let res = reader.result
    //             resolve(res)
    //         }
    //         reader.onerror = reject;
    //         reader.readAsDataURL(blob);
    //     })
    // }


    const initModels = () => {
        return new Promise((resolve, reject) => {
            if (!!drawKey) {
                setLoadingTip('正在加载模型');
                findPrimitivesInGraphic(projectId).then(res => {
                    if (graphicStore.extraContext.getCurrentViewEditor()) {
                        let jsonList: Primitive[] = res.data || [];
                        let entities = jsonList.map((json: Primitive) => {
                            if (graphicStore.context.modelContext.getModelConstructor(json.properties.type)) {
                                let entity: ModelBase = new (graphicStore.context.modelContext.getModelConstructor(json.properties.type))();
                                entity.fromJson(json.properties);
                                return entity;
                            } else {
                                console.log('no match primitive type', json.properties.type)
                            }
    
                        });
                        graphicStore.extraContext.getCurrentViewEditor().addObjects(entities);
                    }
                    isInit.current = true
                    resolve(1);
                })
            } else if (!!roofSlabUuid || !!gutterUuid) {
                graphicStore.extraContext.getCurrentViewEditor().entityDict = {};
                graphicStore.extraContext.getCurrentViewEditor().renderControl.clearObjectsStates();
                resolve(1);
            }
        });
    }


    return (
        <div style={{ display: "flex", flexDirection: "column", flex: "1 1 auto" }}>
            <div className="draw-panel" ref={drawRef}>
                <div className='viewport-item'>
                    {/* todo 只能用"viewport"，pytha库里model都用的viewport取得element，model修改后这里可以修改viewportId */}
                    <Viewport needCube={true} sceneUpdate={sceneUpdate} viewportId='viewport' viewHelperId='viewHelper-1'
                        cameraType={systemContext?.currentCameraType} isDisplay={false} />
                </div>
                <SensorParamPop />
                <DeviceDetailPop />
                <DymodeInput
                    context={graphicStore.context}
                    extraContext={graphicStore.extraContext}
                    leftOffset={20}
                    topOffset={20}
                />
                <MaskLoadingModal
                    visible={loading}
                    height='70px'
                    loadingTip={loadingTip}
                />
            </div>
            <div className="bottom">
                <StmodeInput width={sideBarWidth} />
                <SystemSwitch />
            </div>
        </div>

    )
}